<template>
  <div class="login-container">
    <div class="fx_paper">
      <div class="fx_wrap login_wrap">
        <h3 class="fx_h3">
          <template v-if="systemName">
            <img v-if="logoImg" class="logo_xs" :src="logoImg"/>
            <el-divider v-if="logoImg" direction="vertical"></el-divider>
            <span class="title">{{systemName}}</span>
          </template>
          <img v-else-if="logoImg" class="logo" :src="logoImg"/>
        </h3>
        <div class="mid_line"></div>
        <div class="form_wrap">
          <el-form  label-width="86px" :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="用户名" prop="account">
              <el-input id="form-username" v-model="ruleForm.account" placeholder="工号/用户名" clearable></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" v-if="pwdType === 'pwd'">
              <el-input :type="passwordType" v-model="ruleForm.password" placeholder="密码" clearable>
                <i
                slot="suffix"
                class="el-icon-view el-input__icon"
                title="显示密码"
                @click="passwordType='text'"
                style="cursor:pointer;"
                v-if="passwordType=='password'"
              ></i>
              <i
                slot="suffix"
                class="el-icon-more el-input__icon"
                title="隐藏密码"
                @click="passwordType='password'"
                style="cursor:pointer;"
                v-else
              ></i>
              </el-input>
            </el-form-item>
            <el-form-item v-else-if="pwdType === 'pwdSMS'" label="密码/验证码" prop="password" class="fx_verification">
              <el-input type="password" v-model="ruleForm.password" placeholder="密码/验证码" show-password clearable></el-input>
              <el-button type="default" size="mini" @click="getVerificationCode" :disabled="verCodeDisable">{{timeText}}</el-button>
            </el-form-item>
            <el-form-item class="btn" label-width="0px">
                <el-button
                  :loading="logining"
                  type="primary"
                  @click="handleSubmit">
                  登录
                </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
export default {
  name: 'kyLogin',
  components: {},
  props:{
    systemName: {
      String,
      default: ''
    },
    pwdType:{
      // pwd、pwdSMS
      String,
      default:'pwd'
    },
    logoImg:{
      String,
      default:''
    },
    loadingLogin:{
      Boolean,
      default: false
    },
    downTime: {
      Number,
      default: 60
    }
  },
  data() {
    return {
      ruleForm: {
        account: '',
        password: ''
      },
      rules: {
        account: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      },
      visible: true,
      redirect: '',
      otherQuery: '',
      dialogVisible: false, // 告知书
      passwordType: 'password',
      timeText: '获取验证码'
    }
  },
  created() {
    this.keyupSubmit() // 回车登录
  },
  mounted() {
    var onFocus = document.querySelector('#form-username')
    onFocus.focus()
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      }
    }
  },
  computed: {
    verCodeDisable() {
      let val = this.ruleForm.account
      if (val == '') {
        return true
      }
      let phoneFlag = true
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (!myreg.test(val)) {
        phoneFlag = false
      }
      return !phoneFlag || this.timeText !== '获取验证码'
    },
    logining: {
      get() {
        return this.loadingLogin
      },
      set(val) {
        this.$emit('update:loadingLogin', val)
      }
    }
  },
  methods: {
    keyupSubmit() {
      // 回车登录
      document.onkeydown = e => {
        let _key = window.event.keyCode
        if (_key === 13) {
          this.handleSubmit()
        }
      }
    },
    // 提交
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.logining = true
          var loginParams = {
            account: this.ruleForm.account,
            password: this.ruleForm.password
          }
          this.$emit('handleSubmit',loginParams)
        } else {
          return false
        }
      })
    },
    // 密码显示状态切换
    changePass(value) {
      this.visible = !(value === 'show')
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    // 获取验证码
    getVerificationCode() {
      /* 获取验证码 */
      this.$emit('sendSMS',this.ruleForm.account);
      // verificationCodeSMS({ username: this.ruleForm.account })
      let time = this.downTime
      this.timeText = `重新获取(${time})`
      let inter = setInterval(() => {
        time--
        this.timeText = `重新获取(${time})`
        this.$forceUpdate()
        if(time<=0){
          clearInterval(inter)
          this.timeText = '获取验证码'
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
$bg: #31414f;
.login-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: $bg;
  .btns{
    position: absolute;
    bottom: 30px;
    left: 40px;
  }
  .fx_paper {
    display: flex;
    width: 800px;
    position: absolute;
    left: 50%;
    top: 50%;
    // border-radius: 8px;
    justify-content: center;
    transform: translate(-50%, -50%);
    background-color: $bg;
    // box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    // overflow: hidden;
    .fx_wrap {
      height: 100%;
      .fx_h3 {
        font-size: 30px;
        text-align: center;
        margin: 10px 0 20px;
        padding-right: 20px;
        .logo_xs {
          width: 50%;
          vertical-align: middle;
        }
        .logo {
          width: 68%;
          vertical-align: middle;
        }
        .title{
          font-size: 26px;
          font-weight: 500;
          color: #fff;
        }
      }
    }
  }
  .link{
    cursor: pointer;
    color: #409EFF;
    position: absolute;
    left: 25px;
    bottom: 14px;
  }
}
.form_wrap /deep/ .el-form-item__label{
  color: #fff;
  line-height: 35px;
}
.form_wrap /deep/ .el-form-item__label::before{
  display: none;
}
.form_wrap /deep/ .el-input__inner{
  height: 35px;
}
.form_wrap /deep/ .el-input__icon{
  line-height: 35px;
}
.form_wrap /deep/ .el-input{
  width: 68%;
}
.form_wrap /deep/ .el-form-item{
  margin-bottom: 15px;
}
.form_wrap /deep/ .el-form-item__content{
  line-height: 35px;
}
.form_wrap /deep/ .el-form-item__error{
  padding-top: 1px;
}
.form_wrap{
  width: 500px;
  margin: 0 auto;
  // box-shadow: 3px 3px 3px 0px #293742 , 1px 1px 0px 0px #405565 inset;
  padding: 40px 40px 25px;
  position: relative;
  box-sizing: border-box;
  .el-form{
    position: relative;
  }
  .btn{
    position: absolute;
    display: inline-block;
    top: 0px;
    right: 0px;
    .el-button{
      width: 85px;
      height: 85px;
    }
  }
}
.el-divider--vertical{
  margin-left: -20px;
  opacity: 0.5;
}
.mid_line{
  opacity: 0.5;
  width: 100%;
  height: 1px;
  background: linear-gradient(left bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 100%)
}
.fx_verification{
  width:100%;
}
.fx_verification /deep/ .el-form-item__content{
  display: flex;
}
.fx_verification /deep/ .el-input--suffix{
  width: 38%;
}
.fx_verification /deep/.el-button{
  width: 90px;
  padding: 7px 4px;
  margin-left: 10px;
  border-radius: 4px;
}
</style>




// WEBPACK FOOTER //
// packages/login/src/Login.vue